import { render } from "./transactions.vue?vue&type=template&id=6a89965c"
import script from "./transactions.vue?vue&type=script&lang=ts"
export * from "./transactions.vue?vue&type=script&lang=ts"

import "./transactions.vue?vue&type=style&index=0&id=6a89965c&lang=scss"
script.render = render

export default script